import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import "@/assets/styles/index.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Button from "@/components/common/Button.vue";
import InputField from "@/components/common/InputField.vue";
import LoadingSymbol from "@/components/common/LoadingSymbol.vue";
import Checkbox from "@/components/common/Checkbox.vue";
import aclRules from "./aclRules";
import VueAcl from "vue-browser-acl";
import "@fortawesome/fontawesome-svg-core/styles.css";

const user = () => store.state.auth.user;
Vue.use(VueAcl, user, aclRules, { router });

library.add(fas);
library.add(far);
Vue.component("FontAwesomeIcon", FontAwesomeIcon);
Vue.component("InputField", InputField);
Vue.component("Button", Button);
Vue.component("Checkbox", Checkbox);
Vue.component("Loading", LoadingSymbol);
Vue.config.productionTip = false;
Vue.filter("truncate", function (text, stop, clamp) {
  return text.slice(0, stop) + (stop < text.length ? clamp || "..." : "");
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
